import { useEffect, useState } from 'react';
import { FlexGrid, Typography, useThemeProvider, Card, Skeleton, Link, Button, useDialog } from '@albo-ui/core';
import { Box, Divider, MenuItem, TextField } from '@mui/material';
import { AccountBalance, ContactPhone, Add } from '@mui/icons-material';
import { ManageCommissions } from '../../modals/sales-manager/ManageComissions';
import { customStyles2 } from '../../../util/TableStyles';
import { noDataComponent } from '../../../util/DataObject';
import { useCRMDescription } from './hooks/useCRMDescription';
import { paginationComponentOptions } from '../../../util/i18n-es';
import { CRMCreateRegister } from './CRMCreateRegister';
import emptyList from "../../../images/emptyList.png";
import DataTable from 'react-data-table-component';
import moment from 'moment';
moment.locale('es');

export const CRMDescription = ({changeAlert, changeWidgets, changeLoader, config, section, lead, platformData, platformInfo, catalogs, crmType, getLeadByUuid, agentList, partnerList}: any) => {
    const dialogProps = useDialog();
    const { theme } = useThemeProvider();
    const [ showMenu, setShowMenu ] = useState(false);
    const [ changeStatus, setChangeStatus ] = useState(null);
    const { data, columns, info, loading: loadingTable, page, perPage, totalRows, check, handlePageChange, handlePerRowsChange, onChangeStatus, onChangeAgent, handleGetInfo, onUpdateCommissions } = useCRMDescription(changeAlert, changeWidgets, config, lead, platformData, platformInfo, getLeadByUuid)
    const crmAdmin = localStorage.config && JSON.parse(localStorage.config)["crmAdmin"] ? JSON.parse(localStorage.config)["crmAdmin"] : false;

    useEffect(() => {
        if(crmType){
            handleGetInfo(section, lead, crmType, agentList, partnerList)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [section, lead, agentList, partnerList]);
    useEffect(() => {
        changeLoader(loadingTable)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable]);

    const onOpenAction = () => {
        function isWithinThreeMonths(dateString: string): boolean {
            const inputDate = new Date(dateString);
            const currentDate = new Date();
            const threeMonthsAgo = new Date();
            threeMonthsAgo.setMonth(currentDate.getMonth() - 3);
            return inputDate >= threeMonthsAgo && inputDate <= currentDate;
        }

        if(lead["create_customer_date"] && isWithinThreeMonths(lead["create_customer_date"])){
            dialogProps.openDialog();
        } else {
            crmAdmin ? dialogProps.openDialog() : changeAlert(true, 'error', 'No posees autorización para realizar ésta acción.');
        }
    };
    const onCloseDialogAction = () => {
        dialogProps.onClose();        
    };
    const onConfirmAction = (payload) => {
        dialogProps.onClose();
        onUpdateCommissions(payload, section)
    };

    const headerData = (key, label, type, catalog = null, agents = null, item_key = null, i) => {
        let getClean = info.filter((a) => a.section === section || a.section === "all");
        let getStatus = (cat) => {
            let st = cat.filter((a) => (a.key || a.v) === lead[item_key]);
            return st.length > 0 ? st[0].label || st[0]["m"][0]["description"] : lead[item_key] || "Por iniciar"
        }
        
        return (
            <FlexGrid key={label} style={{width: `${100/getClean.length}%`}} container >
            <FlexGrid item style={{width: "-webkit-fill-available"}}>
                <Typography variant='paragraph' style={{fontSize: 12, lineHeight: 1.5, display: "block"}} bold >{label}</Typography>
                {catalog && platformData[catalog] && !loadingTable ? 
                    type === "disabled" ?
                    <Typography variant='paragraph' style={{fontSize: 12}}>
                        {getStatus(platformData[catalog])}
                    </Typography>
                    :
                    <TextField select value={lead[item_key] || -1} onChange={checkStatus.bind(this, section, item_key)} InputProps={{style: {fontSize: 12}}} sx={{"& .MuiSelect-select": {whiteSpace: "break-spaces !important"}}}
                        variant='standard' size='small' color='secondary'  InputLabelProps={{ shrink: true }}>
                        <MenuItem value={-1} disabled>Seleccione</MenuItem>
                        {platformData[catalog].map((item) => (
                            <MenuItem key={item.key || item.k} value={item.key || item.v}>{item.label || item["m"][0]["description"]}</MenuItem>
                        ))}
                    </TextField>
                    :
                    agents ?
                        <TextField select value={check ? lead['agent']['uuid'] : -2} disabled={!crmAdmin} InputProps={{style: {fontSize: 12}}} sx={{"& .MuiSelect-select": {whiteSpace: "break-spaces !important"}}}
                            variant='standard' size='small' color='secondary'  InputLabelProps={{ shrink: true }}>
                            <MenuItem value={-1} disabled>Seleccione</MenuItem>
                            {!check && <MenuItem value={-2} disabled>{lead['agent']['name'] ? lead['agent']['name'] + " Inactivo" : "Por Asignar" }</MenuItem>}
                            {agents.map((item) => {
                                return <MenuItem key={item.uuid} value={item['uuid']} onClick={onChangeAgent.bind(this, item, section)}>{item.name || 'Inactivo'}</MenuItem>
                            })}
                        </TextField>
                    :
                    type === "button" ?
                        <Button onClick={() => onOpenAction()} buttonType="secondary" size="small" style={{marginTop: 10, width: "-webkit-fill-available"}}>Ingresar</Button>
                    :
                    <Typography variant='paragraph' style={{fontSize: 12}}>
                        {type === 'date' ? moment(key).format('LL') : (key && typeof(key) !== "object" && key['email']) || (key && (typeof(key) !== "object")) ? key : "N/A" }
                    </Typography>
                
                }
            </FlexGrid>
            {(i+1) < info.length && <Divider key={i+1} orientation='vertical' sx={{ mx: 2}}/>}
            </FlexGrid>
        )
    }

    const openMenu = (data?) => {
        setShowMenu(true);
        if(data){
            setChangeStatus(data);
        }
    };

    const closeMenu = (status?) => {
        if(status === "created" && changeStatus){
            onChangeStatus(changeStatus[0], changeStatus[1], changeStatus[2]["e"]);
        } else {
            setChangeStatus(null);
        }
        setShowMenu(false);
    };

    const checkStatus = (section, item_key, e) => {
        let val = e.target.value
        if(item_key === "status" && (val === "sql" || val === "mql")){
            openMenu([section, item_key, {e: {target: {value: e.target.value}}}]);
        } else {
            onChangeStatus(section, item_key, e);
        }
    };

    return (
        <FlexGrid style={{display: 'block', height: "500px"}} container fullWidth >
            {loadingTable ?
                <Skeleton width='100%' height='100px' />
                :    
                <Card padding={3} flexDirection='row' fullWidth justifyContent='space-between' alignItems='stretch' style={{ borderColor: theme.colors.manatee, margin: "3px 3px 10px", height: "23%" }}> 
                    {lead && info.map((item, i) => (item.section === section || item.section === 'all') && headerData(lead[item.key], item.label, item.type, item.catalog, item["agents"] ? agentList : item.agents, item.key, i))}
                </Card>
            }
            <Card padding={3} fullWidth justifyContent='space-between' alignItems='stretch' style={{ borderColor: theme.colors.manatee, margin: 3, WebkitBoxAlign: 'center', display: 'block', height: "75%" }}> 
                <FlexGrid container fullWidth justify='space-between'>
                    <Typography variant='smallTitle' style={{display: 'flex', alignItems: 'center', textTransform: 'uppercase' }} >{section === 'company' ? <><ContactPhone sx={{ mr: 1 }}/>Contactos</> : <><AccountBalance sx={{ mr: 1 }}/>Empresas</> }</Typography>
                    <Box display={'flex'}>
                        <Link onClick={() => openMenu(null)} bold underlined style={{ display: 'flex',  alignItems: 'center', justifyContent: "end", marginRight: 20 }} typography='smallTitle'>
                            <Add style={{ marginRight: 4, marginLeft: -8 }} /> Agregar {section === "company" ? "contacto" : "empresa"}
                        </Link>
                    </Box>
                </FlexGrid>
                
                <FlexGrid container style={{margin: '25px 0', width: '100%' }} direction='column'>
                    { loadingTable ?
                        <Skeleton width='100%' height='100px' />
                        :
                        data.length > 0 && <DataTable
                            columns={columns}
                            data={data}
                            customStyles={customStyles2}
                            noDataComponent={noDataComponent}
                            pagination
                            paginationServer
                            paginationDefaultPage={page}
                            paginationPerPage={perPage}
                            paginationTotalRows={totalRows}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}
                            paginationComponentOptions={paginationComponentOptions}
                            expandOnRowClicked={false}
                        />
                    }
                    { data.length === 0 && !loadingTable &&
                        <FlexGrid item style={{display: "grid", paddingBottom: '0.8rem', marginTop: 30, alignSelf: 'center'}}>
                            <Box component="img" my={2} alignSelf={"center"} alt="emptyList" src={emptyList} width={180}/>
                            <Typography variant='paragraph' style={{textAlign: "center"}} >
                                No hay {section === "company" ? "contactos" : "empresas"} para mostrar
                            </Typography>
                        </FlexGrid>
                    }
                </FlexGrid>
            </Card>
            
            <CRMCreateRegister 
                changeAlert={changeAlert}
                changeLoader={changeLoader}
                config={config}
                sectionData={lead}
                formSelected={section === 'company' ? platformData && platformInfo[0][platformData['createContact']] : platformData && platformInfo[1][platformData['createCompany']]}
                platformData={platformData}
                platformInfo={platformInfo}
                selectedSection={section}
                open={showMenu}
                onClose={closeMenu}
                catalogs={catalogs}
                getLeadByUuid={getLeadByUuid}
                crmType={crmType}
            />

            <ManageCommissions
                item={lead}
                fromTable={false}
                type={"lead"}
                open={dialogProps.open}
                onClose={onCloseDialogAction}
                onConfirm={onConfirmAction}
                changeLoader={changeLoader}
                changeAlert={changeAlert}
            />
        </FlexGrid>
    );
};
